import { render, staticRenderFns } from "./AccountPermissionExplainer.vue?vue&type=template&id=0f9d09f6"
import script from "./AccountPermissionExplainer.vue?vue&type=script&lang=js"
export * from "./AccountPermissionExplainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports